import { createUseStyles } from 'react-jss'

import { LightTheme } from '../../theme'

import { ColumnProps } from './column.types'

export const useStyle = createUseStyles((theme: LightTheme) => ({
  column: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    alignItems: (props: ColumnProps) => props.alignItems || 'center',
    justifyContent: (props: ColumnProps) => props.justifyContent || 'center',
    height: (props: ColumnProps) => (props.fullHeight ? '100%' : 'auto'),
    width: (props: ColumnProps) => (props.fullWidth ? '100%' : 'auto'),
    scrollbarFaceColor: theme.colors.grey /* Firefox 63 compatibility */,
    scrollbarTrackColor: 'transparent',
    scrollbarColor: `${theme.colors.grey} transparent`,
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      width: 4,
      height: 4
    },
    /* Track */
    '&::-webkit-scrollbar-track': {
      background: 'transparent'
    },
    /* Handle */
    '&::-webkit-scrollbar-thumb': {
      background: theme.colors.grey,
      borderRadius: 14
    },
    /* Handle on hover */
    '&::-webkit-scrollbar-thumb:hover': {
      background: theme.colors.hoverGrey
    }
  },
  fullFilledHeight: {
    height: '100vh!important'
  }
}))
